import type { HelpArticleBlockProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import { helpCenterImages } from '../../utils';
import HelpLinkedText from '../HelpLinkedText/HelpLinkedText';

const HelpArticleBlock = ({ block, onNavigate }: HelpArticleBlockProps) => {
  switch (block.t) {
    case 'h2':
      return <h3 className={styles.articleHeading}>{block.text}</h3>;

    case 'p':
      return (
        <p className={styles.articleText}>
          <HelpLinkedText
            text={block.text}
            links={block.links}
            onNavigate={onNavigate}
          />
        </p>
      );

    case 'ul':
      // Every list renders as numbered steps, per Figma.
      return (
        <ol className={styles.articleStepList}>
          {block.items.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key -- steps have no id; the list is static
            <li key={index}>
              <HelpLinkedText
                text={item}
                links={block.item_links?.[index]}
                onNavigate={onNavigate}
              />
            </li>
          ))}
        </ol>
      );

    case 'fig': {
      const src = block.placeholder ? undefined : helpCenterImages[block.src];
      // Caption is used as alt text only; Figma shows no visible caption.
      return (
        <figure className={styles.articleFigure}>
          {src ? (
            <img
              className={styles.articleFigureImage}
              src={src}
              alt={block.caption ?? ''}
            />
          ) : (
            <div
              className={styles.articleFigurePlaceholder}
              role='img'
              aria-label={block.caption ?? ''}
            />
          )}
        </figure>
      );
    }

    default:
      return null;
  }
};

export default HelpArticleBlock;
